import { render, staticRenderFns } from "./GarageView.vue?vue&type=template&id=b4e746ec&scoped=true&"
import script from "./GarageView.vue?vue&type=script&lang=js&"
export * from "./GarageView.vue?vue&type=script&lang=js&"
import style0 from "./GarageView.vue?vue&type=style&index=0&id=b4e746ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e746ec",
  null
  
)

export default component.exports